module.exports = __webpack_public_path__ + "img/home_page_six_side_bgx.786f9adb.png";